import PaymentCodesContainer from './payment-codes-container-component';
import PaymentCodesContainerService from './payment-codes-container-service';
import PaymentCodesListModule from './payment-codes-list/payment-codes-list-module';

const MODULE_NAME = 'Trip.payment-codes.container';
const module = angular.module(MODULE_NAME, [
    PaymentCodesListModule,
])
    .directive(PaymentCodesContainer.DIRECTIVE_NAME, PaymentCodesContainer)
    .service('paymentCodesContainerService', PaymentCodesContainerService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-container-module.js